module.exports = __webpack_public_path__ + "img/sepah.65d19c38.png";